import { serverPost } from '@/util';

// 从接口获取翻译资源
export async function fetchTranslations(headers = {}) {
  try {
    const { data } = await serverPost(
      'https://front-key.duetapp.net/v1/project/translation',
      {
        project: 'DUET H5 Content',
      },
      headers
    );
    return data;
  } catch (error) {
    console.error('Failed to fetch translations:', error);
    return null;
  }
}

const LAN_LIST = ['zh-Hant', 'zh-CN', 'en', 'th', 'id', 'ms', 'ja'];

function getLan(lan) {
  if (lan === 'zh-HK' || lan === 'zh-TW') {
    return 'zh-Hant';
  }
  if (lan === 'zh-CN') {
    return 'zh-CN';
  }
  if (lan === 'en-US') {
    return 'en';
  }
  if (lan === 'th-TH') {
    return 'th';
  }
  if (lan === 'id-ID') {
    return 'id';
  }
  if (lan === 'ms-MY') {
    return 'ms';
  }
  if (lan === 'ja-JP') {
    return 'ja';
  }
  // 英语兜底
  return 'en';
}

export function processTransltionData(transList) {
  const result = {};
  LAN_LIST.forEach((lan) => (result[lan] = { translation: {} }));
  transList?.forEach((item) => {
    result[getLan(item.language)].translation[item.key] = item.text;
  });
  return result;
}
